<template>
  <NuxtLink
    :to="link"
    class="bg-surface-action-2 hover:bg-surface-action-hover border-1 border-border-tertiary rounded-md w-full py-20 px-16 no-underline focus-rounded"
    external
  >
    <div class="flex items-center gap-8 mb-8">
      <slot name="left-icon" />
      <p class="heading-xxs">{{ headingLabel }}</p>
      <nuxt-icon
        name="arrow-right"
        class="text-text-primary text-[2.4rem] ml-auto"
        :filled="false"
      />
    </div>
    <p>{{ text }}</p>
  </NuxtLink>
</template>

<script lang="ts" setup>
interface Props {
  link: string;
  headingLabel: string;
  text: string;
}

defineProps<Props>();
</script>
